/**
 * 遅延スクロール機能
 * 遅延処理でレイアウト安定化を待つ
 */
const delayedScroll = () => {
  /**
   * ヘッダー高さ（CSS変数）+ WP管理バー高さ + 余白をオフセットとして返す
   * @see set-header-height-variable.js
   */
  const getScrollOffset = () => {
    const rootStyle = window.getComputedStyle(document.documentElement);

    const headerHeightProp = rootStyle.getPropertyValue('--js-height__header');
    const adminBarHeightProp = rootStyle.getPropertyValue(
      '--wp-admin--admin-bar--height',
    );

    const toNumber = (value) => {
      const match = String(value).match(/([0-9.]+)/);
      return match ? parseFloat(match[1]) : 0;
    };

    let offset = toNumber(headerHeightProp) + toNumber(adminBarHeightProp);

    // CSS変数が未設定の場合のフォールバック
    if (!offset) {
      const headerElement = document.querySelector('header');
      if (headerElement) {
        offset = headerElement.offsetHeight;
      }
    }

    // 追従ヘッダー下に少し余白を確保（tabs.js と同様の意図）
    return offset + 20;
  };

  /**
   * ヘッダー高さを考慮して対象要素へスクロールする
   */
  const scrollToTargetWithOffset = (targetElement) => {
    const offset = getScrollOffset();
    const top =
      targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  };

  // href属性に"#"が含まれるすべての<a>要素を取得
  document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const href = anchor.getAttribute('href');
      if (!href) return;
      const hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      const targetId = href.substring(hashIndex);
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        event.preventDefault();
        // 遅延してからスクロール（レイアウト安定化のため）
        setTimeout(() => {
          scrollToTargetWithOffset(targetElement);
        }, 50);
      }
    });
  });

  /**
   * ページ読み込み時のハッシュ処理
   */
  const handleInitialHash = () => {
    const hash = window.location.hash;
    if (hash && hash !== '#') {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        setTimeout(() => {
          scrollToTargetWithOffset(targetElement);
        }, 200);
      }
    }
  };

  // ページ読み込み完了後にハッシュ処理を実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }
};

export { delayedScroll };
